<template>
  <f7-list-item @click.capture="toggle" style="cursor: pointer;">
    <span>{{label}}</span>
    <f7-toggle :checked="value" style="pointer-events: none;"/>
  </f7-list-item>
</template>

<script>
  export default {
    // the following line *needs* to include "list-input" for f7-list to recognise it.
    name: 'list-input-toggle',
    props: {
      label: {
        type: String,
        required: true,
      },
      checked: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        value: this.checked,
      }
    },
    methods: {
      toggle () {
        this.value = !this.value
      },
    },
    watch: {
      value: {
        handler (newVal) {
          this.$emit('change', newVal)
        },
      },
    },
    model: {
      prop: 'checked',
      event: 'change',
    }
  }
</script>
